module.exports = __webpack_public_path__ + "sitepen-logo.g7Uwd2wv.svg";